import{PublicKey as o}from"@solana/web3.js";import{MINT_PREFIX as r,NAME_TOKENIZER_ID as s}from"./const.mjs";const t=t=>{const[n]=o.findProgramAddressSync([r,t.toBuffer()],s);return n};export{t as getDomainMint};
//# sourceMappingURL=getDomainMint.mjs.map
